import { EfficientFrontier } from 'actions';

const initialState = {
  isFetching: false,
  excluded_tickers: [],
  included_tickers: [],
  init_date: '',
  end_date: '',
  frontier: [],
  y_axis: '',
  x_axis: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case EfficientFrontier.EFFICIENTFRONTIER_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case EfficientFrontier.EFFICIENTFRONTIER_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        excluded_tickers: action.data.excluded_tickers,
        included_tickers: action.data.included_tickers,
        init_date: action.data.init_date,
        end_date: action.data.end_date,
        frontier: action.data.frontier,
        y_axis: action.data.y_axis,
        x_axis: action.data.x_axis,
      };
    case EfficientFrontier.EFFICIENTFRONTIER_UPDATE:
      return {
        ...state,
        [action.field]: action.value,
      };
    case EfficientFrontier.EFFICIENTFRONTIER_FAIL:
      return initialState;
    case EfficientFrontier.EFFICIENTFRONTIER_CLEAR:
      return initialState;
    case EfficientFrontier.EFFICIENTFRONTIER_ABORT:
      return initialState;
    default:
      return state;
  }
}
